import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "main-page"
};
import { onMounted } from "vue";
export default {
  __name: 'App',
  setup(__props) {
    // import NavHeader from "@/components/NavHeader";
    onMounted(() => {
      // 获取查询字符串
      const queryString = window.location.href.split('?')[1];
      const params = new URLSearchParams(queryString);
      const communityId = params.get('communityId');
      console.log(communityId);
      setCommunityId(communityId);
    });
    const setCommunityId = id => {
      if (id && id != null && id != 'null') {
        localStorage.setItem("communityId", id);
      }
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view)]);
    };
  }
};